import { render } from "./BookingsList.vue?vue&type=template&id=740cf10a"
import script from "./BookingsList.vue?vue&type=script&lang=js"
export * from "./BookingsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__